import { environment } from "@/components/constants";
export const trackUserSearch = (searchTerm) => {
    if (!searchTerm) return
    if (environment !== 'prod') return;
    if (window.dataLayer) {
        window.dataLayer.push({
            event: "search",
            search_term: searchTerm,
        });
    } else {
        console.warn("GTM dataLayer is not available");
    }
};

// Example Usage:
